declare var StringHelpers;

export default {
    props: {
        target: {},
        targetElement: {
            type: [Object, null],
            default: null,
        },
        enabled: {
            type: Boolean,
            default: true,
        },
        getSpoInfoFn: Function,
        hotelPromotions: {
            type: Array,
            default: () => [],
        },
    },
    data() {
        return {
            info: null,
        };
    },
    computed: {
        expiresInText() {
            if (this.info.expiresInText) {
                return StringHelpers.Format(this.$res.Views.PackageSearch_Promotion_ExpirationTimeLeftFormat, [this.info.expiresInText]);
            }
        },
        showFooter() {
            return !!this.info && !!this.info.expirationDateText;
        },
    },
    methods: {
        onShow() {
            if (!this.info) {
                this.info = this.getSpoInfoFn();
            }
        },
        getPromotionStyle(promotion) {
            return {
                backgroundColor: promotion.badgeBackgroundColor,
                color: promotion.badgeForegroundColor || "#fff",
            };
        },
    },
}


